











































































































































































































































































// TODO 快判任务 无数据 render 需要改为slot 调试
// 此页面为 普通任务、团队任务、快判任务、练习任务公共列表页
import { Component, Vue, Watch } from "vue-property-decorator";
import { goTop } from "@/global/utils";
import { pracLogs } from "@/api/task/train";
import { logs as crowdLogs } from "@/api/task/crowd";
import { teamLogs, teamLeaderLogs } from "@/api/team/team";
import {
  getTaskLogs,
  getLibLogs,
  getDetail,
  getProblemLog,
} from "@/api/user/user";
import { DOMAIN } from "@/global/constants";

@Component
export default class Message extends Vue {
  [x: string]: any;
  private taskList = [
    {
      value: "-1",
      label: "全部",
    },
    {
      value: "0",
      label: "普通任务",
    },
    {
      value: "1",
      label: "团队任务",
    },
    {
      value: "2",
      label: "练习题任务",
    },
    {
      value: "3",
      label: "指定任务",
    },
  ];
  private getTeamTask(teamTask) {
    if (teamTask === 0) {
      return { value: "crowd", label: "普通任务" };
    } else if (teamTask === 1) {
      return { value: "team", label: "团队任务" };
    } else if (teamTask === 2) {
      return { value: "train", label: "练习任务" };
    } else if (teamTask === 3) {
      return { value: "crowd", label: "指定任务" };
    } else if (teamTask === 5) {
      return { value: "crowd", label: "题包任务" };
    }
  }
  private gettaskType(type) {
    if (type == 0) {
      return "全部类型";
    } else if (type == 1) {
      return "打点计数";
    } else if (type == 2) {
      return "标注任务";
    } else if (type == 3) {
      return "文字转写";
    } else if (type == 4) {
      return "快判任务";
    } else if (type == 5) {
      return "审核任务";
    } else if (type == 6) {
      return "质检任务";
    } else if (type == 7) {
      return "平台任务";
    } else if (type == 8) {
      return "采集任务";
    } else if (type == 9) {
      return "筛选任务";
    } else if (type == 10) {
      return "审核任务";
    } else {
      return "其他";
    }
  }

  private columns: object = {
    taskall: [
      {
        title: "任务Id",
        key: "id",
        align: "center",
      },
      {
        title: "任务名称",
        key: "title",
        align: "center",
      },
      {
        title: "任务类别",
        slot: "teamType",
        align: "center",
      },
      {
        title: "任务类型",
        slot: "taskType",
        align: "center",
      },
      {
        title: "操作",
        slot: "operate",
        align: "center",
      },
    ],
    train: [
      {
        title: "做题数量",
        key: "cnt",
        align: "center",
      },
      {
        title: "经验值",
        key: "scores",
        align: "center",
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
      },
    ],
    crowd: [
      {
        title: "日期",
        slot: "day",
        align: "center",
      },
      {
        title: "做题数量",
        key: "nums",
        align: "center",
      },
      {
        title: "新增做题数量",
        key: "new_nums",
        align: "center",
      },
      {
        title: "无需标注",
        key: "undo_nums",
        align: "center",
      },
      {
        title: "初验成功",
        key: "vs_nums",
        align: "center",
      },
      // {
      //   title: "初验失败",
      //   slot: "vsFail",
      //   align: "center",
      // },
      {
        title: "质检成功",
        key: "snums",
        align: "center",
      },
      {
        title: "当日做题质检通过数",
        key: "check_pass_nums",
        align: "center",
      },
      {
        title: "验收成功",
        key: "vs_nums",
        align: "center",
      },
      {
        title: "提交标注结果",
        key: "submit",
        align: "left",
        slot: "submit",
        width: 150,
      },
      {
        title: "质检通过结果",
        slot: "items",
        key: "items",
        align: "left",
        width: 150,
      },
      {
        title: "元素统计结果",
        slot: "elementCount",
        key: "elementCount",
        align: "left",
        width: 150,
      },
      {
        title: "审核质检失败",
        key: "fnums",
        align: "center",
      },
      {
        title: "成功率",
        slot: "rate",
        key: "rate",
        align: "center",
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
      },
    ],
    check: [
      {
        title: "日期",
        slot: "day",
        align: "center",
      },
      {
        title: "做题数量",
        key: "nums",
        align: "center",
      },
      {
        title: "质检成功",
        key: "snums",
        align: "center",
      },
      {
        title: "初验成功",
        key: "vs_nums",
        align: "center",
      },
      // {
      //   title: "初验失败",
      //   slot: "vsFail",
      //   align: "center",
      // },
      {
        title: "验收成功",
        key: "vs_nums",
        align: "center",
      },
      {
        title: "提交标注结果",
        key: "submit",
        align: "left",
        slot: "submit",
        width: 150,
      },
      {
        title: "质检通过结果",
        slot: "items",
        key: "items",
        align: "left",
        width: 150,
      },
      {
        title: "元素统计结果",
        slot: "elementCount",
        key: "elementCount",
        align: "left",
        width: 150,
      },
      {
        title: "审核质检失败",
        key: "fnums",
        align: "center",
      },
      {
        title: "成功率",
        slot: "rate",
        key: "rate",
        align: "center",
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
      },
    ],
    judge: [
      {
        title: "任务名称",
        key: "center",
      },
      {
        title: "价格",
        key: "amount",
        align: "center",
        slot: "amount",
      },
      {
        title: "做题数量",
        key: "lib_nums",
        align: "center",
      },
      {
        title: "剩余题数",
        key: "nums",
        align: "center",
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
      },
    ],
    team: [
      {
        title: "日期",
        slot: "day",
        align: "center",
      },
      {
        title: "做题数量",
        key: "nums",
        align: "center",
      },
      {
        title: "新增做题数量",
        key: "new_nums",
        align: "center",
      },
      {
        title: "无需标注",
        key: "undo_nums",
        align: "center",
      },
      {
        title: "初验成功",
        key: "vs_nums",
        align: "center",
      },
      // {
      //   title: "初验失败",
      //   slot: "vsFail",
      //   align: "center",
      // },
      {
        title: "质检成功",
        key: "snums",
        align: "center",
      },
      {
        title: "验收成功",
        key: "vs_nums",
        align: "center",
      },
      {
        title: "提交标注结果",
        key: "submit",
        align: "left",
        slot: "submit",
        width: 150,
      },
      {
        title: "质检通过结果",
        align: "left",
        slot: "items",
        key: "items",
        width: 150,
      },
      {
        title: "元素统计结果",
        slot: "elementCount",
        key: "elementCount",
        align: "left",
        width: 150,
      },
      {
        title: "审核质检失败",
        key: "fnums",
        align: "center",
      },
      {
        title: "成功率",
        slot: "rate",
        key: "rate",
        align: "center",
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
      },
    ],
    type10: [
      {
        title: "日期",
        slot: "day",
        align: "center",
        width: 150,
      },
      {
        title: "初验成功",
        key: "vs_nums",
        width: 100,
        align: "center",
      },
      // {
      //   title: "初验失败",
      //   slot: "vsFail",
      //   width: 100,
      //   align: "center",
      // },
      {
        title: "做题数量",
        key: "nums",
        align: "center",
        width: 155,
        renderHeader: (h, params) => {
          return h("div", [
            h(
              "p",
              {
                domProps: { innerHTML: "做题数量" },
                style: { "text-align": "center" },
              },
              ""
            ),
            h(
              "p",
              {
                domProps: {
                  innerHTML:
                    "操作一次就记录一次，一个题目打回重做后，重新审核会增加做题数量",
                },
                style: {
                  "font-weight": "normal",
                  "text-align": "left",
                  "margin-top": "5px",
                },
              },
              ""
            ),
          ]);
        },
      },
      {
        title: "审核通过数量",
        key: "pnums",
        align: "center",
        width: 150,
        renderHeader: (h, params) => {
          return h("div", [
            h(
              "p",
              {
                domProps: { innerHTML: "审核通过数量" },
                style: { "text-align": "center" },
              },
              ""
            ),
            h(
              "p",
              {
                domProps: { innerHTML: "操作审核成功的次数" },
                style: {
                  "font-weight": "normal",
                  "text-align": "left",
                  "margin-top": "5px",
                },
              },
              ""
            ),
          ]);
        },
      },
      {
        title: "审核不通过数量",
        key: "bnums",
        width: 110,
        align: "center",
        renderHeader: (h, params) => {
          return h("div", [
            h(
              "p",
              {
                domProps: { innerHTML: "审核不通过数量" },
                style: { "text-align": "center" },
              },
              ""
            ),
            h(
              "p",
              {
                domProps: { innerHTML: "操作不通过成功的次数" },
                style: {
                  "font-weight": "normal",
                  "text-align": "left",
                  "margin-top": "5px",
                },
              },
              ""
            ),
          ]);
        },
      },
      {
        title: "打回修改数量",
        key: "rnums",
        align: "center",
        width: 150,
        renderHeader: (h, params) => {
          return h("div", [
            h(
              "p",
              {
                domProps: { innerHTML: "打回修改数量" },
                style: { "text-align": "center" },
              },
              ""
            ),
            h(
              "p",
              {
                domProps: { innerHTML: "操作打回修改的次数" },
                style: {
                  "font-weight": "normal",
                  "text-align": "left",
                  "margin-top": "5px",
                },
              },
              ""
            ),
          ]);
        },
      },
      {
        title: "无需标注",
        key: "undo_nums",
        align: "center",
        width: 150,
      },
      {
        title: "提交标注结果",
        key: "submit",
        align: "left",
        slot: "submit",
        width: 150,
      },
      {
        title: "成功标注结果",
        align: "left",
        key: "items",
        slot: "items",
        width: 150,
      },
      {
        title: "元素统计结果",
        slot: "elementCount",
        key: "elementCount",
        align: "left",
        width: 150,
      },
      {
        title: "成功数量",
        key: "snums",
        align: "center",
        width: 150,
        renderHeader: (h, params) => {
          return h("div", [
            h(
              "p",
              {
                domProps: { innerHTML: "成功数量" },
                style: { "text-align": "center" },
              },
              ""
            ),
            h(
              "p",
              {
                domProps: { innerHTML: "审核通过，并且被系统拟合成功的数量" },
                style: {
                  "font-weight": "normal",
                  "text-align": "left",
                  "margin-top": "5px",
                },
              },
              ""
            ),
          ]);
        },
      },
      {
        title: "失败数量",
        key: "fnums",
        align: "center",
        width: 150,
        renderHeader: (h, params) => {
          return h("div", [
            h(
              "p",
              {
                domProps: { innerHTML: "失败数量" },
                style: { "text-align": "center" },
              },
              ""
            ),
            h(
              "p",
              {
                domProps: { innerHTML: "审核通过，但被系统拟合失败的数量" },
                style: {
                  "font-weight": "normal",
                  "text-align": "left",
                  "margin-top": "5px",
                },
              },
              ""
            ),
          ]);
        },
      },
      {
        title: "验收成功率",
        slot: "rate",
        align: "center",
        width: 150,
        renderHeader: (h, params) => {
          return h("div", [
            h(
              "p",
              {
                domProps: { innerHTML: "验收成功率" },
                style: { "text-align": "center" },
              },
              ""
            ),
            h(
              "p",
              {
                domProps: { innerHTML: "验收成功数量/验收通过的数量" },
                style: {
                  "font-weight": "normal",
                  "text-align": "left",
                  "margin-top": "5px",
                },
              },
              ""
            ),
          ]);
        },
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
        width: 150,
      },
      {
        title: "当日做题质检通过数",
        key: "check_pass_nums",
        align: "center",
        width: 150,
      },
    ],
    day: [
      {
        title: "任务id",
        key: "mid",
        align: "center",
      },
      {
        title: "用户id",
        key: "uid",
        width: "120",
        align: "center",
      },
      {
        title: "题目id",
        key: "lid",
        align: "center",
      },
      {
        title: "题包名",
        key: "pkg_name",
        align: "center",
      },
      {
        title: "题包ID",
        key: "pkg_id",
        align: "center",
      },
      {
        title: "提交时间",
        key: "time",
        width: "220",
        align: "center",
        sortable: 'custom',
      },
      {
        title: "任务结算",
        slot: "logPrice",
        align: "center",
      },
      {
        title: "任务状态",
        slot: "status",
        align: "center",
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
      },
      {
        title: "查看详情",
        slot: "check",
        align: "center",
        width: "150",
        filters: [
                    {
                        label: '可以修改',
                        value: 1
                    },
                    {
                        label: '不能修改',
                        value: 2
                    }
                ],
                filterMultiple: false,
                filterMethod (value, row) {
                    if (value === 1) {
                        return row.history_modify === 1;
                    } else if (value === 2) {
                        return row.history_modify === 0;
                    }
                }
      },
    ],
    logs: [
      {
        title: "题目id",
        key: "lid",
        align: "center",
      },
      {
        title: "任务id",
        key: "mid",
        align: "center",
      },
      {
        title: "操作人id",
        key: "uid",
        align: "center",
      },
      {
        title: "任务类型",
        key: "type",
        align: "center",
      },
      {
        title: "时间",
        key: "time",
        align: "center",
      },
      {
        title: "奖励规则下统计的题数/金额",
        key: "active_statistic",
        align: "center",
      },
      {
        title: "操作",
        slot: "h_operate",
        align: "center",
      },
    ],
  };

  // 全部任务搜索
  private allSearchParams = {
    id: "",
    teamTask: "-1",
  };
  // 全部任务分页
  private allPageParams = {
    page: 1,
    pagesize: 20,
  };

  // 练习题搜索
  private trainSearchParams = {
    type: "",
    title: "",
    tid: "",
  };
  // 练习题入参
  private trainPageParams = {
    page: 1,
    rows: 20,
  };

  // 普通任务\快判任务入参
  private detailPageParams = {
    page: 1,
    pagesize: 20,
  };
  // 团队 普通 指定任务搜索
  private detailSearchParams = {
    mid: "",
    uid: "",
  };
  // 做题日志入参
  private daySearchParams = {
    mid: "",
    uid: "",
    ctime: "",
    sortType: 2
  };
  // 做题日志分页
  private dayPageParams = {
    page: 1,
    rows: 20,
  };
  // 处理结果入参
  private logsSearchParams: any = {
    lid: "",
  };
  // 处理结果分页
  private logsPageParams = {
    page: 1,
    rows: 20,
  };

  // 1 全部任务 2 查看任务详情 3 做题日志
  private visiableFlag = "1";

  private allTotal: number = 0;
  private allList: any = [];

  private detailToTal: number = 0;
  private detailList: any = [];

  private dayTotal: number = 0;
  private dayList: any = [];

  private logsTotal: number = 0;
  private logsList: any = [];

  private currentTask: string = "";
  private detailPage: string = "";
  private currentTitle: string = "";
  private currentLog: string = "";

  @Watch("$route")
  private routechange(to: any, from: any) {
    if (to.name !== from.name) {
      this.init(); // 重新加载数据
    }
  }
  get userInfo() {
    return this.$store.state.userInfo;
  }
  private created() {
    this.init();
    this.$eventBus.$on("menu-state-reset", (routerName) => {
      if (routerName == this.$route.name) {
        this.visiableFlag = "1";
      }
    });
  }
  private init() {
    this.taskSearch();
  }
  private getDetail() {
    if (this.currentTask === "train") {
      this.getTrain({});
    } else {
      this.getTaskDetail();
    }
  }

  // 全部任务查询
  private taskSearch() {
    let obj = {};
    if (this.allSearchParams.id != "") {
      obj["id"] = this.allSearchParams.id;
    }
    if (this.allSearchParams.teamTask != "-1") {
      obj["teamTask"] = this.allSearchParams.teamTask;
    }
    this.getTask(obj);
  }
  // 获取全部任务
  private async getTask(obj) {
    const params = { ...this.allPageParams, ...obj };
    const res: any = await getTaskLogs(params);
    this.$nextTick(() => {
      this.allList = res.rows;
      this.allTotal = res.total;
    });
  }

  // 获取任务详细列表
  private async getTaskDetail() {
    const params = { ...this.detailPageParams, ...this.detailSearchParams };
    let res: any;
    if (this.userInfo.offline_leader) {
      res = await teamLeaderLogs(params);
    } else {
      res = await crowdLogs(params);
    }
    this.$nextTick(() => {
      this.detailList = res && res.rows;
      this.detailToTal = res && res.total;
      this.detailList.forEach((item) => this.getLineNum(item));
    });
  }

  //任务搜索
  private commonSearch(type) {
    if (this.detailSearchParams[type] === "") {
      return;
    } else {
      this.getTaskDetail();
    }
  }

  // 获取练习任务 列表
  private async getTrain(param) {
    const params = { ...this.trainPageParams, ...param };
    const res: any = await pracLogs(params);
    this.$nextTick(() => {
      this.detailList = res.rows;
      this.detailToTal = res.total;
      this.detailList.forEach((item) => this.getLineNum(item));
    });
  }

  // 练习任务搜索
  private trainSearch(type) {
    if (this.trainSearchParams[type] === "") {
      return;
    } else {
      let obj = {};
      obj[type] = this.trainSearchParams[type];
      obj["rows"] = 1;
      this.getTrain(obj);
    }
  }

  // 查看详情
  private showDetail(row) {
    this.visiableFlag = "2";
    this.currentTitle = `${row.title} (${row.id})`;
    let taskType = this.getTeamTask(row.team_task).value;
    if (taskType == "train") {
      this.currentTask = taskType;
      this.trainSearchParams.tid = row.id;
    } else {
      if (row.type == 10) {
        this.currentTask = "type10";
      } else if (row.type == 6) {
        this.currentTask = "check";
      } else {
        this.currentTask = taskType;
      }
      (this.detailSearchParams as any).mid = row.id;
    }
    this.getDetail();
  }

  // 返回列表
  private goBack(step) {
    this.visiableFlag = step;
  }
  // 查看用户某天做改任务什么题
  private showDayDetail(row) {
    let obj = {
      mid: row.mid,
      uid: row.uid,
      ctime: row.day,
    };
    this.daySearchParams = Object.assign(this.daySearchParams, obj);
    this.currentLog = `${row.day} 任务日志`;
    this.getDayList();
  }
  // 查询日志列表
  private async getDayList() {
    let params = { ...this.daySearchParams, ...this.dayPageParams };
    let res: any = await getLibLogs(params);
    this.$nextTick(() => {
      this.visiableFlag = "3";
      this.dayList = res.rows;
      this.dayTotal = res.total;
    });
  }

  private sortCustomer(column, key, order) {
    let sortType = 2;
    if(column.order === 'asc'){
       sortType = 1;
    }
    // 排序的方式
    this.daySearchParams.sortType = sortType
    this.getDayList()
  }
  // 查看结果
  private async openDetail(mid: number) {
    try {
      const res = await getDetail({ mlid: mid });
      const result = res as any;
      let from = result.module.from;
      if (from.indexOf("sketch") > -1) {
        from = from.indexOf("-") > -1 ? from.split("-")[1] : "markPage";
      }
      window.open(
        `${DOMAIN}/tools/${from}.html?type=56&qid=${result.mlid}&inspectmid=${result.mid}`
      );
    } catch (err) {
      console.log(err);
    }
  }

  // 审核前修改答案
  private async openEdit({ mlid, type }) {
    let openType
    if (type == 2 || type == '标注') {
      openType = '52-1'
    }
    if (type == 10 || type == '新审核') {
      openType = '55-1'
    }
    try {
      const res = await getDetail({ mlid: mlid });
      const result = res as any;
      let from = result.module.from;
      if (from.indexOf("sketch") > -1) {
        from = from.indexOf("-") > -1 ? from.split("-")[1] : "markPage";
      }
      window.open(
        `${DOMAIN}/tools/${from}.html?type=${openType}&eid=${result.mlid}&id=${result.mid}&lid=${result.lid}&version=2`
      );
    } catch (err) {
      console.log(err);
    }
  }

  // 查看日志
  private getListLog(id: number) {
    this.visiableFlag = "4";
    this.logsSearchParams = { lid: id };
    this.getLogsList();
  }
  // 处理日志列表获取

  private async getLogsList() {
    let obj = { ...this.logsPageParams, ...this.logsSearchParams };
    try {
      const res = await getProblemLog(obj);
      if ((res as any).rows.length > 0) {
        this.logsList = (res as any).rows;
      }
      this.logsTotal = (res as any).total;
    } catch (err) {
      console.log(err);
    }
    goTop();
  }

  // 重置
  private reset() {
    if (this.visiableFlag == "1") {
      this.allSearchParams = {
        id: "",
        teamTask: "-1",
      };
      this.taskSearch();
    } else if (this.visiableFlag == "2") {
      if (this.currentTask === "train") {
        for (let key in this.trainSearchParams) {
          this.trainSearchParams[key] = "";
        }
        this.getTrain({});
      } else if (this.currentTask === "crowd") {
        this.detailSearchParams.uid = "";
      }
    }
  }

  // 全部任务分页
  private changeAllPageNum(page) {
    this.allPageParams.page = page;
    this.taskSearch();
    goTop();
  }

  // 任务明细分页
  private changeDetailPage(page) {
    if (this.currentTask === "train") {
      this.trainPageParams.page = page;
      // 条件搜索时 只有一条数据 无分页 所以请求无需加其他参数
      this.getTrain({});
    } else {
      this.detailPageParams.page = page;
      this.getTaskDetail();
    }
    goTop();
  }

  // 某日做题记录分页
  private changeDayPageNum(page) {
    this.dayPageParams.page = page;
    this.getDayList();
    goTop();
  }

  // 处理结果分页
  private changeLogsPageNum(page) {
    this.logsPageParams.page = page;
    this.getLogsList();
    goTop();
  }

  private expandHandler(row, index) {
    this.$set(this.detailList[index], "canOpen", !row.canOpen);
  }

  private getLineNum(row) {
    let sList = [],
      iList = [];
    if (row.submit) {
      row.submit = row.submit.trim();
      if (row.submit.endsWith("<br>")) {
        row.submit = row.submit.slice(0, -4);
      }
      sList = row.submit.split("<br>");
    }
    if (row.items) {
      row.items = row.items.trim();
      if (row.items.endsWith("<br>")) {
        row.items = row.items.slice(0, -4);
      }
      iList = row.items.split("<br>");
    }
    row.canExpandIcon = sList.length > 3 || iList.length > 3;
  }
}
